document.querySelectorAll('[data-rs-gallery]').forEach((gallery) => {
  const track = gallery.querySelector('.rs-gallery__track');
  const slides = [...track.querySelectorAll(':scope > img')];
  const thumbs = [...gallery.querySelectorAll('.rs-gallery__thumbs button')];
  const count = gallery.querySelector('.rs-gallery__count b');
  let current = 0;
  const show = (index) => {
    current = (index + slides.length) % slides.length;
    track.style.transform = `translateX(-${current * 100}%)`;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
    thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === current));
    count.textContent = current + 1;
  };
  gallery.querySelector('.rs-gallery__prev')?.addEventListener('click', () => show(current - 1));
  gallery.querySelector('.rs-gallery__next')?.addEventListener('click', () => show(current + 1));
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
});
